const FIELD_ROUTE_KEY = 'lgl.field.lastRoute';

const storageOf = (win) => {
  try {
    return win?.sessionStorage || null;
  } catch {
    return null;
  }
};

export function rememberFieldRoute(pathname, search = '', win = typeof window === 'undefined' ? undefined : window) {
  if (typeof pathname !== 'string' || !pathname.startsWith('/m')) return;
  const storage = storageOf(win);
  if (!storage) return;
  try {
    storage.setItem(FIELD_ROUTE_KEY, `${pathname}${search || ''}`);
  } catch {
    /* private mode */
  }
}

export function peekFieldRoute(win = typeof window === 'undefined' ? undefined : window) {
  const storage = storageOf(win);
  if (!storage) return null;
  try {
    return storage.getItem(FIELD_ROUTE_KEY);
  } catch {
    return null;
  }
}

export function consumeFieldRoute(win = typeof window === 'undefined' ? undefined : window) {
  const next = peekFieldRoute(win);
  if (!next) return null;
  try {
    storageOf(win)?.removeItem(FIELD_ROUTE_KEY);
  } catch {
    /* ignore */
  }
  return next;
}
